import { readSmartCategory } from './read'

export const smartCategories = {
  read: readSmartCategory,
}
